"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var EventNames = /*#__PURE__*/function () {
  function EventNames() {
    (0, _classCallCheck2["default"])(this, EventNames);
  }

  (0, _createClass2["default"])(EventNames, null, [{
    key: "OCSDKLOAD",
    get: function get() {
      return "oc:sdk:load";
    }
  }]);
  return EventNames;
}();

exports["default"] = EventNames;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9Db21tb24vRXZlbnROYW1lcy50cyJdLCJuYW1lcyI6WyJFdmVudE5hbWVzIl0sIm1hcHBpbmdzIjoiOzs7Ozs7Ozs7Ozs7O0lBQXFCQSxVOzs7Ozs7O1NBQ25CLGVBQXNDO0FBQUUsYUFBTyxhQUFQO0FBQXVCIiwic291cmNlUm9vdCI6Im9jc2RrOi8vLyIsInNvdXJjZXNDb250ZW50IjpbImV4cG9ydCBkZWZhdWx0IGNsYXNzIEV2ZW50TmFtZXMge1xuICBwdWJsaWMgc3RhdGljIGdldCBPQ1NES0xPQUQoKTogc3RyaW5nIHsgcmV0dXJuIFwib2M6c2RrOmxvYWRcIjsgfVxufVxuIl19